import { AuthOptions } from '@aws-amplify/auth/lib-esm/types'

const LOCAL = false

export const cognitoConfig: AuthOptions = {
  region: 'us-east-1',
  userPoolId: 'us-east-1_x5Yv0L7eP',
  userPoolWebClientId: '1n486o7tmoudgkvne1r628ner7',
  identityPoolId: 'us-east-1:38a66310-4969-4c21-b95e-6a6c0700272e',

  oauth: {
    domain: 'preprod-partscout.auth.us-east-1.amazoncognito.com',
    scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: !LOCAL
      ? 'https://www.partscout.me/sign-in/success'
      : 'http://localhost:8080/sign-in/success',
    redirectSignOut: !LOCAL ? 'https://www.partscout.me/' : 'http://localhost:8080/',
    responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
  },
}
